import { observable }          from 'rewire-core';
import {
  DeepPartial,
  IGroup,
  ProductName
}                              from '../DataTypes';
import addGroupDialogModel, {
  IAddGroupDialogData
}                              from '../side-navigation/AddGroupDialogModel';
import areaSettingsDialogModel from '../side-navigation/AreaSettingsDialogModel';
import mainPageModel           from './MainPageModel';
import { RouteManagerBase }    from './RouteManager';

export enum GroupDisplayMode {
  Cards = 'cards',
  List  = 'list',
}

export interface IAreaModelState {
  mode:    GroupDisplayMode;
  areaId?: string;
}

export class AreaModel {
  state: IAreaModelState = observable({
    mode:   GroupDisplayMode.Cards,
    areaId: undefined,
  });

  constructor() {
  }

  updateTitle() {
    const { areaId } = RouteManagerBase.current;
    const area       = areaId && mainPageModel.areaMap[areaId] || undefined;
    const areaName   = area?.name;
    const newTitle   = areaName
                        ? `Schedule - ${areaName} - ${ProductName}`
                        : `Schedule - ${ProductName}`;
    if (window.document.title !== newTitle) {
      window.document.title = newTitle;
    }
  }

  reset() {
    this.state.areaId = undefined;
  }

  load = async (areaId: string) => {
    this.state.areaId = areaId;
  };

  get areaId(): string | undefined {
    return this.state.areaId;
  }

  get area(): {id: string, name: string, code: string, groups: DeepPartial<IGroup>[]} | undefined {
    return this.areaId && mainPageModel.areaMap[this.areaId] || undefined;
  }

  get areaName(): string | undefined {
    return this.area?.name;
  }

  get groups(): DeepPartial<IGroup>[] {
    return this.area?.groups ?? [];
  }

  get mode() {
    return this.state.mode;
  }

  setMode(mode: GroupDisplayMode) {
    this.state.mode = mode;
  }

  showAddGroupDialog() {
    if (!this.areaId || !this.areaName) return;

    const addGroupData: IAddGroupDialogData = {
      areaId: this.areaId,
      areaName: this.areaName,
    };

    addGroupDialogModel.load(addGroupData);
  }

  showAreaSettingsDialog() {
    if (!this.areaId) return;

    areaSettingsDialogModel.load(this.areaId);
  }
}

const areaModel = new AreaModel();
export default areaModel;
